import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";
import { AlertCircle } from "lucide-react";
import t from "@/lang/lang";
import { Username } from "@/services/backend/auth/components/username";
import { Immutability } from "@bitory-gmbh/nidavellir";
import { Document } from "@bitory-gmbh/bsm";

export function DocumentImmutableAlert(props: {
  document: Document & Immutability;
}) {
  const { document } = props;
  if (!document.immutable) {
    return null;
  }

  const documentKind = t(document.documentKind);
  const setAt = document.immutabilitySetAt
    ? new Date(document.immutabilitySetAt).toLocaleString()
    : "";
  const setBy = document.immutabilitySetBy;

  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{documentKind} festgeschrieben</AlertTitle>
      <AlertDescription>
        <span>
          {`${documentKind} wurde am ${setAt} von `}
          <Username userId={setBy ?? ""} />
          {` festgeschrieben.`}
        </span>
      </AlertDescription>
    </Alert>
  );
}
